import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { ApiIntegration } from "../../_services/api.integration";
import { Globals } from '../../_models/globals';
import { User } from '../../_models/user';
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-package-configuration',
  templateUrl: './package-configuration.component.html',
  styleUrls: ['./package-configuration.component.css']
})
export class PackageConfigurationComponent implements OnInit {
  packageType: string;
  weight: string;
  boxHeight: string;
  boxWidth: string;
  boxLength: string;
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  package: any = [];
  deletePackageConf: any;

  constructor(private alertService: AlertService, private api: ApiIntegration, public user: User, private router: Router, private http: HttpClient, private g: Globals) {
    this.g.page = "Package Type";
    if (this.user.role == "ROLE_ADMIN") {
      this.getPackage();
    }
    else if (this.user.role == "ACCOUNT_OWNER") {
      this.accountOwnerGetPackage();
    }
    else if (this.user.role == "AO_SELLER") {
      this.sellerGetPackage();
    }
  }

  getPackage() {
    this.g.loaderDisplay = "display";
    this.api.getPackingTypesList("1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.package = data.getPackingTypesResponses;
    },
      err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
  }

  accountOwnerGetPackage() {
    this.g.loaderDisplay = "display";
    this.api.getPackingTypesListAccount(this.user.accountOwnerId, "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.package = data.getPackingTypesResponses;
    },
      err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
  }

  sellerGetPackage() {
    this.g.loaderDisplay = "display";
    this.api.getPackingTypesListSeller(this.user.sellerId, "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.package = data.getPackingTypesResponses;
    },
      err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
  }


  clearPackage() {
    this.packageType = "";
    this.weight = "";
    this.boxHeight = "";
    this.boxWidth = "";
    this.boxLength = ""
  }

  ngOnInit() {
  }

  typePackage() {
    this.statusText1 = "";
    if (this.packageType == '' || this.packageType === null || this.packageType === undefined || this.packageType === 'undefined') {
      this.statusText1 = 'Please enter package type';
    }
  }

  typeLength() {
    this.statusText2 = "";
    if (this.boxLength == '' || this.boxLength === null || this.boxLength === undefined || this.boxLength === 'undefined') {
      this.statusText2 = 'Please enter length';
    }
  }

  typeWidth() {
    this.statusText3 = "";
    if (this.boxWidth == '' || this.boxWidth === null || this.boxWidth === undefined || this.boxWidth === 'undefined') {
      this.statusText3 = 'Please enter width';
    }
  }

  typeHeight() {
    this.statusText4 = "";
    if (this.boxHeight == '' || this.boxHeight === null || this.boxHeight === undefined || this.boxHeight === 'undefined') {
      this.statusText4 = 'Please enter height';
    }
  }

  typeWeight() {
    this.statusText5 = "";
    if (this.weight == '' || this.weight === null || this.weight === undefined || this.weight === 'undefined') {
      this.statusText5 = 'Please enter weight';
    }
  }

  submitPackage() {
    this.g.loaderDisplay = "display";
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";

    if (this.packageType == '' || this.packageType === null || this.packageType === undefined || this.packageType === 'undefined') {
      this.statusText1 = 'Please enter package type';
    }
    if (this.boxLength == '' || this.boxLength === null || this.boxLength === undefined || this.boxLength === 'undefined') {
      this.statusText2 = 'Please enter length';
    }
    if (this.boxWidth == '' || this.boxWidth === null || this.boxWidth === undefined || this.boxWidth === 'undefined') {
      this.statusText3 = 'Please enter width';
    }
    if (this.boxHeight == '' || this.boxHeight === null || this.boxHeight === undefined || this.boxHeight === 'undefined') {
      this.statusText4 = 'Please enter height';
    }

    if (this.weight == '' || this.weight === null || this.weight === undefined || this.weight === 'undefined') {
      this.statusText5 = 'Please enter weight';
    }

    if (this.statusText1 != "" || this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "" || this.statusText5 != "") {
      this.g.loaderDisplay = "";
      return false;
    }

    let figure = {};
    if (this.user.role == "ROLE_ADMIN") {
      figure = {
        "packingType": this.packageType,
        "weight": this.weight,
        "height": this.boxHeight,
        "length": this.boxLength,
        "width": this.boxWidth,
        "organizationId": 1,
      }
    }

    if (this.user.role == "ACCOUNT_OWNER") {
      figure = {
        "packingType": this.packageType,
        "weight": this.weight,
        "height": this.boxHeight,
        "length": this.boxLength,
        "width": this.boxWidth,
        "organizationId": 1,
        "accountOwnerId": this.user.accountOwnerId
      }
    }

    if (this.user.role == "AO_SELLER") {
      figure = {
        "packingType": this.packageType,
        "weight": this.weight,
        "height": this.boxHeight,
        "length": this.boxLength,
        "width": this.boxWidth,
        "organizationId": 1,
        "sellerId": this.user.sellerId
      }
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/createPackingTypes', figure,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Package Type', 'Created Successfully');
          this.router.navigate(['/admin/packageType']);
          this.weight = "";
          this.packageType = "";
          this.boxHeight = "";
          this.boxWidth = "";
          this.boxLength = "";
          if (this.user.role == "ROLE_ADMIN") {
            this.getPackage();
          }
          else if (this.user.role == "ACCOUNT_OWNER") {
            this.accountOwnerGetPackage();
          }
          else if (this.user.role == "AO_SELLER") {
            this.sellerGetPackage();
          }
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  selectedDeleteReturn(p) {
    this.deletePackageConf = p;
  }


  deletePackage() {
    let deleteRecord = {};
    if (this.user.role == "ROLE_ADMIN") {
      deleteRecord = {
        "id": this.deletePackageConf.id
      }
    }

    if (this.user.role == "ACCOUNT_OWNER") {
      deleteRecord = {
        "id": this.deletePackageConf.id,
        "accountOwnerId": this.user.accountOwnerId,
        "organizationId": 1
      }
    }

    if (this.user.role == "AO_SELLER") {
      deleteRecord = {
        "id": this.deletePackageConf.id,
        "sellerId": this.user.sellerId
      }
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/deletePackingTypes', deleteRecord,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Package Type', 'Deleted Successfully');
          this.router.navigate(['/admin/packageType']);
          if (this.user.role == "ROLE_ADMIN") {
            this.getPackage();
          }
          else if (this.user.role == "ACCOUNT_OWNER") {
            this.accountOwnerGetPackage();
          }
          else if (this.user.role == "AO_SELLER") {
            this.sellerGetPackage();
          }
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
}
